import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import { toast } from "react-toastify";

import axios from "axios";
import config from "../../function/config";
import Usernav from "../UserHome/Usernav";
import AdminNav from "../Admin/AdminHome/AdminNav";
import HomeNav from "../Navbars/HomeNav";

export default function RegistrationFormCharter() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [user, setUser] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log("User:", res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [token]);

  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [vesselType, setvesselType] = useState("");
  const [YearBuilt, setYearBuilt] = useState("");
  const [DWT, setDWT] = useState("");
  const [Email, setEmail] = useState("");
  const [MobileNO, setMobileNO] = useState("");
  const [BriefDescription, setBriefDescription] = useState("");
  const [OpenArea, setOpenArea] = useState("");
  const [TCVC, setTCVC] = useState("");
  const [Category, setCategory] = useState("");
  const [Subject, setSubject] = useState("");
  const [count, setCount] = useState(0);
  const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
  const [LoadingPort,setLoadingPort] = useState('');
  const [DischargePort,setDischargePort] = useState('');
  const [TypeOfCargo,setTypeOfCargo] = useState('');
  const [CompanyAddress,setCompanyAddress] = useState('');
  const [Company,setCompany] = useState('');
  const [name,setName] = useState('');
  const [Lychan,setLychan] = useState('')

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Limit to 3 images max
    if (files.length + selectedImages.length > 3) {
      toast.error("You can only upload up to 3 images.");
      return;
    }

    const newFiles = files.map((file) => {
      file.preview = URL.createObjectURL(file);
      return file;
    });

    setSelectedImages((prev) => [...prev, ...newFiles]);
  };

  const removeImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  const [generatedCode, setGeneratedCode] = useState("");

  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");

  const subCategoryPrefixes = {
    barge: "BRG",
    bulk: "BLK",
    cargo: "CRG",
    container: "CNT",
    fishing: "FIS",
    multipurpose: "MPP",
    passengerferry: "PAX",
    reefer: "REF",
    roro: "ROR",
    tanker: "TNK",
    tugboat: "TUG",
    dredger: "DRG",
    floatingcrane: "FLC",
    landingcraft: "LCT",
    Yacht: "YCT",
    supplyboat: "SUB",
    crewboat: "CRB",
    floatingdock: "FLD",
    other: "OTR",
  };

  useEffect(() => {
    if (vesselType) {
      const normalized = normalize(vesselType);
      const prefix = subCategoryPrefixes[normalized];
      if (prefix) {
        setGeneratedCode(prefix); // ✅ Only set the prefix
      } else {
        setGeneratedCode("");
      }
    }
  }, [vesselType]);

  const userId = localStorage.getItem("userId");
  const [refCode, setRefCode] = useState("");
  const [Url, setUrl] = useState("");

  const handleSubmitCharter = async (e, id) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();

    // Append text fields
     formData.append("vessel_type", vesselType);
    formData.append("user", userId);
    formData.append("url_new", Url);
    formData.append("tc_vc", TCVC);
    formData.append("year_built", YearBuilt);
    formData.append("open_area", selectedCountry);
    formData.append("DWT", DWT);
    formData.append("email", Email);
    formData.append("phone", MobileNO);
    formData.append("brief_description", BriefDescription);
    formData.append("name", name);
    formData.append("company_address", CompanyAddress);
    formData.append("company", Company);
    formData.append("ship_code", refCode);
    formData.append("lychan", Lychan);

    // ✅ Append multiple images correctly
    if (selectedImages.length > 0) {
      selectedImages.forEach((img) => {
        formData.append("images", img); // 'images' matches backend key
      });
    }

    try {
      const response = await axios.post(
        `https://marinizbackend.mariniz.com/api/HappyMarineShipping/RegShipForCharter`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );
      console.log("API Response:", response.data);
      if (response.data.status === 200) {
        navigate("/regShip");
        setLoading(false);
        toast.success("Registered Successfully!", {
          autoClose: 1500,
          position: "top-right",
        });

        // Reset form state
        setCount(id);
        setvesselType("");
        setDWT("");
        setEmail("");
        setSelectedImages([]); // ✅ clear selected images
        setMobileNO("");
        setOpenArea("");
        setYearBuilt("");
        setSelectedCountry("");
        setBriefDescription("");
        setTCVC("");
      } else {
        setLoading(false);
        toast.error("Fill the  Fields", {
          autoClose: 1500,
          position: "top-right",
        });
      }
    } catch (err) {
      setLoading(false);
      console.error("Error:", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  const { pathname } = useLocation();
  const [selectedCountry, setSelectedCountry] = useState(null);

  const regions = {
    Asia: [
      {
        value: "Afghanistan",
        label: "Afghanistan",
        flag: "https://flagcdn.com/w320/af.png",
      },
      {
        value: "Armenia",
        label: "Armenia",
        flag: "https://flagcdn.com/w320/am.png",
      },
      {
        value: "Azerbaijan",
        label: "Azerbaijan",
        flag: "https://flagcdn.com/w320/az.png",
      },
      {
        value: "Bahrain",
        label: "Bahrain",
        flag: "https://flagcdn.com/w320/bh.png",
      },
      {
        value: "Bangladesh",
        label: "Bangladesh",
        flag: "https://flagcdn.com/w320/bd.png",
      },
      {
        value: "Brunei",
        label: "Brunei",
        flag: "https://flagcdn.com/w320/bn.png",
      },
      {
        value: "Cambodia",
        label: "Cambodia",
        flag: "https://flagcdn.com/w320/kh.png",
      },
      {
        value: "China",
        label: "China",
        flag: "https://flagcdn.com/w320/cn.png",
      },
      {
        value: "Cyprus",
        label: "Cyprus",
        flag: "https://flagcdn.com/w320/cy.png",
      },
      {
        value: "Georgia",
        label: "Georgia",
        flag: "https://flagcdn.com/w320/ge.png",
      },
      {
        value: "India",
        label: "India",
        flag: "https://flagcdn.com/w320/in.png",
      },
      {
        value: "Indonesia",
        label: "Indonesia",
        flag: "https://flagcdn.com/w320/id.png",
      },
      { value: "Iran", label: "Iran", flag: "https://flagcdn.com/w320/ir.png" },
      { value: "Iraq", label: "Iraq", flag: "https://flagcdn.com/w320/iq.png" },
      {
        value: "Israel",
        label: "Israel",
        flag: "https://flagcdn.com/w320/il.png",
      },
      {
        value: "Japan",
        label: "Japan",
        flag: "https://flagcdn.com/w320/jp.png",
      },
      {
        value: "Jordan",
        label: "Jordan",
        flag: "https://flagcdn.com/w320/jo.png",
      },
      {
        value: "Kazakhstan",
        label: "Kazakhstan",
        flag: "https://flagcdn.com/w320/kz.png",
      },
      {
        value: "Kuwait",
        label: "Kuwait",
        flag: "https://flagcdn.com/w320/kw.png",
      },
      {
        value: "Kyrgyzstan",
        label: "Kyrgyzstan",
        flag: "https://flagcdn.com/w320/kg.png",
      },
      { value: "Laos", label: "Laos", flag: "https://flagcdn.com/w320/la.png" },
      {
        value: "Lebanon",
        label: "Lebanon",
        flag: "https://flagcdn.com/w320/lb.png",
      },
      {
        value: "Malaysia",
        label: "Malaysia",
        flag: "https://flagcdn.com/w320/my.png",
      },
      {
        value: "Maldives",
        label: "Maldives",
        flag: "https://flagcdn.com/w320/mv.png",
      },
      {
        value: "Mongolia",
        label: "Mongolia",
        flag: "https://flagcdn.com/w320/mn.png",
      },
      {
        value: "Myanmar",
        label: "Myanmar",
        flag: "https://flagcdn.com/w320/mm.png",
      },
      {
        value: "Nepal",
        label: "Nepal",
        flag: "https://flagcdn.com/w320/np.png",
      },
      {
        value: "North Korea",
        label: "North Korea",
        flag: "https://flagcdn.com/w320/kp.png",
      },
      { value: "Oman", label: "Oman", flag: "https://flagcdn.com/w320/om.png" },
      {
        value: "Pakistan",
        label: "Pakistan",
        flag: "https://flagcdn.com/w320/pk.png",
      },
      {
        value: "Palestine",
        label: "Palestine",
        flag: "https://flagcdn.com/w320/ps.png",
      },
      {
        value: "Philippines",
        label: "Philippines",
        flag: "https://flagcdn.com/w320/ph.png",
      },
      {
        value: "Qatar",
        label: "Qatar",
        flag: "https://flagcdn.com/w320/qa.png",
      },
      {
        value: "Russia",
        label: "Russia",
        flag: "https://flagcdn.com/w320/ru.png",
      },
      {
        value: "Saudi Arabia",
        label: "Saudi Arabia",
        flag: "https://flagcdn.com/w320/sa.png",
      },
      {
        value: "Singapore",
        label: "Singapore",
        flag: "https://flagcdn.com/w320/sg.png",
      },
      {
        value: "Korea",
        label: "Korea",
        flag: "https://flagcdn.com/w320/kr.png",
      },
      {
        value: "Sri Lanka",
        label: "Sri Lanka",
        flag: "https://flagcdn.com/w320/lk.png",
      },
      {
        value: "Syria",
        label: "Syria",
        flag: "https://flagcdn.com/w320/sy.png",
      },
      {
        value: "Taiwan",
        label: "Taiwan",
        flag: "https://flagcdn.com/w320/tw.png",
      },
      {
        value: "Tajikistan",
        label: "Tajikistan",
        flag: "https://flagcdn.com/w320/tj.png",
      },
      {
        value: "Thailand",
        label: "Thailand",
        flag: "https://flagcdn.com/w320/th.png",
      },
      {
        value: "Timor-Leste",
        label: "Timor-Leste",
        flag: "https://flagcdn.com/w320/tl.png",
      },
      {
        value: "Turkey",
        label: "Turkey",
        flag: "https://flagcdn.com/w320/tr.png",
      },
      {
        value: "Turkmenistan",
        label: "Turkmenistan",
        flag: "https://flagcdn.com/w320/tm.png",
      },
      {
        value: "United Arab Emirates",
        label: "United Arab Emirates",
        flag: "https://flagcdn.com/w320/ae.png",
      },
      {
        value: "Uzbekistan",
        label: "Uzbekistan",
        flag: "https://flagcdn.com/w320/uz.png",
      },
      {
        value: "Vietnam",
        label: "Vietnam",
        flag: "https://flagcdn.com/w320/vn.png",
      },
      {
        value: "Yemen",
        label: "Yemen",
        flag: "https://flagcdn.com/w320/ye.png",
      },
    ],

    Africa: [
      {
        value: "Algeria",
        label: "Algeria",
        flag: "https://flagcdn.com/w320/dz.png",
      },
      {
        value: "Angola",
        label: "Angola",
        flag: "https://flagcdn.com/w320/ao.png",
      },
      {
        value: "Benin",
        label: "Benin",
        flag: "https://flagcdn.com/w320/bj.png",
      },
      {
        value: "Botswana",
        label: "Botswana",
        flag: "https://flagcdn.com/w320/bw.png",
      },
      {
        value: "Burkina Faso",
        label: "Burkina Faso",
        flag: "https://flagcdn.com/w320/bf.png",
      },
      {
        value: "Burundi",
        label: "Burundi",
        flag: "https://flagcdn.com/w320/bi.png",
      },
      {
        value: "Cape Verde",
        label: "Cape Verde",
        flag: "https://flagcdn.com/w320/cv.png",
      },
      {
        value: "Cameroon",
        label: "Cameroon",
        flag: "https://flagcdn.com/w320/cm.png",
      },
      {
        value: "Central African Republic",
        label: "Central African Republic",
        flag: "https://flagcdn.com/w320/cf.png",
      },
      { value: "Chad", label: "Chad", flag: "https://flagcdn.com/w320/td.png" },
      {
        value: "Comoros",
        label: "Comoros",
        flag: "https://flagcdn.com/w320/km.png",
      },
      {
        value: "Congo, Democratic Republic of the",
        label: "Congo, Democratic Republic of the",
        flag: "https://flagcdn.com/w320/cd.png",
      },
      {
        value: "Congo, Republic of the",
        label: "Congo, Republic of the",
        flag: "https://flagcdn.com/w320/cg.png",
      },
      {
        value: "Ivory Coast",
        label: "Ivory Coast",
        flag: "https://flagcdn.com/w320/ci.png",
      },
      {
        value: "Djibouti",
        label: "Djibouti",
        flag: "https://flagcdn.com/w320/dj.png",
      },
      {
        value: "Egypt",
        label: "Egypt",
        flag: "https://flagcdn.com/w320/eg.png",
      },
      {
        value: "Equatorial Guinea",
        label: "Equatorial Guinea",
        flag: "https://flagcdn.com/w320/gq.png",
      },
      {
        value: "Eritrea",
        label: "Eritrea",
        flag: "https://flagcdn.com/w320/er.png",
      },
      {
        value: "Ethiopia",
        label: "Ethiopia",
        flag: "https://flagcdn.com/w320/et.png",
      },
      {
        value: "Gabon",
        label: "Gabon",
        flag: "https://flagcdn.com/w320/ga.png",
      },
      {
        value: "Gambia",
        label: "Gambia",
        flag: "https://flagcdn.com/w320/gm.png",
      },
      {
        value: "Ghana",
        label: "Ghana",
        flag: "https://flagcdn.com/w320/gh.png",
      },
      {
        value: "Guinea",
        label: "Guinea",
        flag: "https://flagcdn.com/w320/gn.png",
      },
      {
        value: "Guinea-Bissau",
        label: "Guinea-Bissau",
        flag: "https://flagcdn.com/w320/gw.png",
      },
      {
        value: "Kenya",
        label: "Kenya",
        flag: "https://flagcdn.com/w320/ke.png",
      },
      {
        value: "Lesotho",
        label: "Lesotho",
        flag: "https://flagcdn.com/w320/ls.png",
      },
      {
        value: "Liberia",
        label: "Liberia",
        flag: "https://flagcdn.com/w320/lr.png",
      },
      {
        value: "Libya",
        label: "Libya",
        flag: "https://flagcdn.com/w320/ly.png",
      },
      {
        value: "Madagascar",
        label: "Madagascar",
        flag: "https://flagcdn.com/w320/mg.png",
      },
      {
        value: "Malawi",
        label: "Malawi",
        flag: "https://flagcdn.com/w320/mw.png",
      },
      { value: "Mali", label: "Mali", flag: "https://flagcdn.com/w320/ml.png" },
      {
        value: "Mauritania",
        label: "Mauritania",
        flag: "https://flagcdn.com/w320/mr.png",
      },
      {
        value: "Mauritius",
        label: "Mauritius",
        flag: "https://flagcdn.com/w320/mu.png",
      },
      {
        value: "Morocco",
        label: "Morocco",
        flag: "https://flagcdn.com/w320/ma.png",
      },
      {
        value: "Mozambique",
        label: "Mozambique",
        flag: "https://flagcdn.com/w320/mz.png",
      },
      {
        value: "Namibia",
        label: "Namibia",
        flag: "https://flagcdn.com/w320/na.png",
      },
      {
        value: "Niger",
        label: "Niger",
        flag: "https://flagcdn.com/w320/ne.png",
      },
      {
        value: "Nigeria",
        label: "Nigeria",
        flag: "https://flagcdn.com/w320/ng.png",
      },
      {
        value: "Rwanda",
        label: "Rwanda",
        flag: "https://flagcdn.com/w320/rw.png",
      },
      {
        value: "Sao Tome and Principe",
        label: "Sao Tome and Principe",
        flag: "https://flagcdn.com/w320/st.png",
      },
      {
        value: "Senegal",
        label: "Senegal",
        flag: "https://flagcdn.com/w320/sn.png",
      },
      {
        value: "Seychelles",
        label: "Seychelles",
        flag: "https://flagcdn.com/w320/sc.png",
      },
      {
        value: "Sierra Leone",
        label: "Sierra Leone",
        flag: "https://flagcdn.com/w320/sl.png",
      },
      {
        value: "Somalia",
        label: "Somalia",
        flag: "https://flagcdn.com/w320/so.png",
      },
      {
        value: "South Africa",
        label: "South Africa",
        flag: "https://flagcdn.com/w320/za.png",
      },
      {
        value: "Sudan",
        label: "Sudan",
        flag: "https://flagcdn.com/w320/sd.png",
      },
      {
        value: "Tanzania",
        label: "Tanzania",
        flag: "https://flagcdn.com/w320/tz.png",
      },
      { value: "Togo", label: "Togo", flag: "https://flagcdn.com/w320/tg.png" },
      {
        value: "Tunisia",
        label: "Tunisia",
        flag: "https://flagcdn.com/w320/tn.png",
      },
      {
        value: "Uganda",
        label: "Uganda",
        flag: "https://flagcdn.com/w320/ug.png",
      },
      {
        value: "Zambia",
        label: "Zambia",
        flag: "https://flagcdn.com/w320/zm.png",
      },
      {
        value: "Zimbabwe",
        label: "Zimbabwe",
        flag: "https://flagcdn.com/w320/zw.png",
      },
    ],
    Europe: [
      {
        value: "Albania",
        label: "Albania",
        flag: "https://flagcdn.com/w320/al.png",
      },
      {
        value: "Andorra",
        label: "Andorra",
        flag: "https://flagcdn.com/w320/ad.png",
      },
      {
        value: "Armenia",
        label: "Armenia",
        flag: "https://flagcdn.com/w320/am.png",
      },
      {
        value: "Austria",
        label: "Austria",
        flag: "https://flagcdn.com/w320/at.png",
      },
      {
        value: "Azerbaijan",
        label: "Azerbaijan",
        flag: "https://flagcdn.com/w320/az.png",
      },
      {
        value: "Belarus",
        label: "Belarus",
        flag: "https://flagcdn.com/w320/by.png",
      },
      {
        value: "Belgium",
        label: "Belgium",
        flag: "https://flagcdn.com/w320/be.png",
      },
      {
        value: "Bosnia and Herzegovina",
        label: "Bosnia and Herzegovina",
        flag: "https://flagcdn.com/w320/ba.png",
      },
      {
        value: "Bulgaria",
        label: "Bulgaria",
        flag: "https://flagcdn.com/w320/bg.png",
      },
      {
        value: "Croatia",
        label: "Croatia",
        flag: "https://flagcdn.com/w320/hr.png",
      },
      {
        value: "Cyprus",
        label: "Cyprus",
        flag: "https://flagcdn.com/w320/cy.png",
      },
      {
        value: "Czech Republic",
        label: "Czech Republic",
        flag: "https://flagcdn.com/w320/cz.png",
      },
      {
        value: "Denmark",
        label: "Denmark",
        flag: "https://flagcdn.com/w320/dk.png",
      },
      {
        value: "Estonia",
        label: "Estonia",
        flag: "https://flagcdn.com/w320/ee.png",
      },
      {
        value: "Finland",
        label: "Finland",
        flag: "https://flagcdn.com/w320/fi.png",
      },
      {
        value: "France",
        label: "France",
        flag: "https://flagcdn.com/w320/fr.png",
      },
      {
        value: "Georgia",
        label: "Georgia",
        flag: "https://flagcdn.com/w320/ge.png",
      },
      {
        value: "Germany",
        label: "Germany",
        flag: "https://flagcdn.com/w320/de.png",
      },
      {
        value: "Greece",
        label: "Greece",
        flag: "https://flagcdn.com/w320/gr.png",
      },
      {
        value: "Hungary",
        label: "Hungary",
        flag: "https://flagcdn.com/w320/hu.png",
      },
      {
        value: "Iceland",
        label: "Iceland",
        flag: "https://flagcdn.com/w320/is.png",
      },
      {
        value: "Ireland",
        label: "Ireland",
        flag: "https://flagcdn.com/w320/ie.png",
      },
      {
        value: "Italy",
        label: "Italy",
        flag: "https://flagcdn.com/w320/it.png",
      },
      {
        value: "Kazakhstan",
        label: "Kazakhstan",
        flag: "https://flagcdn.com/w320/kz.png",
      },
      {
        value: "Kosovo",
        label: "Kosovo",
        flag: "https://flagcdn.com/w320/xk.png",
      },
      {
        value: "Latvia",
        label: "Latvia",
        flag: "https://flagcdn.com/w320/lv.png",
      },
      {
        value: "Liechtenstein",
        label: "Liechtenstein",
        flag: "https://flagcdn.com/w320/li.png",
      },
      {
        value: "Lithuania",
        label: "Lithuania",
        flag: "https://flagcdn.com/w320/lt.png",
      },
      {
        value: "Luxembourg",
        label: "Luxembourg",
        flag: "https://flagcdn.com/w320/lu.png",
      },
      {
        value: "Malta",
        label: "Malta",
        flag: "https://flagcdn.com/w320/mt.png",
      },
      {
        value: "Moldova",
        label: "Moldova",
        flag: "https://flagcdn.com/w320/md.png",
      },
      {
        value: "Monaco",
        label: "Monaco",
        flag: "https://flagcdn.com/w320/mc.png",
      },
      {
        value: "Montenegro",
        label: "Montenegro",
        flag: "https://flagcdn.com/w320/me.png",
      },
      {
        value: "Netherlands",
        label: "Netherlands",
        flag: "https://flagcdn.com/w320/nl.png",
      },
      {
        value: "North Macedonia",
        label: "North Macedonia",
        flag: "https://flagcdn.com/w320/mk.png",
      },
      {
        value: "Norway",
        label: "Norway",
        flag: "https://flagcdn.com/w320/no.png",
      },
      {
        value: "Poland",
        label: "Poland",
        flag: "https://flagcdn.com/w320/pl.png",
      },
      {
        value: "Portugal",
        label: "Portugal",
        flag: "https://flagcdn.com/w320/pt.png",
      },
      {
        value: "Romania",
        label: "Romania",
        flag: "https://flagcdn.com/w320/ro.png",
      },
      {
        value: "Russia",
        label: "Russia",
        flag: "https://flagcdn.com/w320/ru.png",
      },
      {
        value: "San Marino",
        label: "San Marino",
        flag: "https://flagcdn.com/w320/sm.png",
      },
      {
        value: "Serbia",
        label: "Serbia",
        flag: "https://flagcdn.com/w320/rs.png",
      },
      {
        value: "Slovakia",
        label: "Slovakia",
        flag: "https://flagcdn.com/w320/sk.png",
      },
      {
        value: "Slovenia",
        label: "Slovenia",
        flag: "https://flagcdn.com/w320/si.png",
      },
      {
        value: "Spain",
        label: "Spain",
        flag: "https://flagcdn.com/w320/es.png",
      },
      {
        value: "Sweden",
        label: "Sweden",
        flag: "https://flagcdn.com/w320/se.png",
      },
      {
        value: "Switzerland",
        label: "Switzerland",
        flag: "https://flagcdn.com/w320/ch.png",
      },
      {
        value: "Turkey",
        label: "Turkey",
        flag: "https://flagcdn.com/w320/tr.png",
      },
      {
        value: "Ukraine",
        label: "Ukraine",
        flag: "https://flagcdn.com/w320/ua.png",
      },
      {
        value: "United Kingdom",
        label: "United Kingdom",
        flag: "https://flagcdn.com/w320/gb.png",
      },
      {
        value: "Vatican City",
        label: "Vatican City",
        flag: "https://flagcdn.com/w320/va.png",
      },
    ],
    America: [
      {
        value: "Antigua and Barbuda",
        label: "Antigua and Barbuda",
        flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Flag_of_Antigua_and_Barbuda.svg/1200px-Flag_of_Antigua_and_Barbuda.svg.png",
      },
      {
        value: "Argentina",
        label: "Argentina",
        flag: "https://flagcdn.com/w320/ar.png",
      },
      {
        value: "Aruba",
        label: "Aruba",
        flag: "https://flagcdn.com/w320/aw.png",
      },
      {
        value: "Bahamas",
        label: "Bahamas",
        flag: "https://flagcdn.com/w320/bs.png",
      },
      {
        value: "Barbados",
        label: "Barbados",
        flag: "https://flagcdn.com/w320/bb.png",
      },
      {
        value: "Belize",
        label: "Belize",
        flag: "https://flagcdn.com/w320/bz.png",
      },
      {
        value: "Bermuda",
        label: "Bermuda",
        flag: "https://flagcdn.com/w320/bm.png",
      },
      {
        value: "Bolivia",
        label: "Bolivia",
        flag: "https://flagcdn.com/w320/bo.png",
      },
      {
        value: "Brazil",
        label: "Brazil",
        flag: "https://flagcdn.com/w320/br.png",
      },
      {
        value: "British Virgin Islands",
        label: "British Virgin Islands",
        flag: "https://flagcdn.com/w320/vg.png",
      },
      {
        value: "Canada",
        label: "Canada",
        flag: "https://flagcdn.com/w320/ca.png",
      },
      {
        value: "Cayman Islands",
        label: "Cayman Islands",
        flag: "https://flagcdn.com/w320/ky.png",
      },
      {
        value: "Chile",
        label: "Chile",
        flag: "https://flagcdn.com/w320/cl.png",
      },
      {
        value: "Colombia",
        label: "Colombia",
        flag: "https://flagcdn.com/w320/co.png",
      },
      {
        value: "Costa Rica",
        label: "Costa Rica",
        flag: "https://flagcdn.com/w320/cr.png",
      },
      {
        value: "Cuba",
        label: "Cuba",
        flag: "https://flagcdn.com/w320/cu.png",
      },
      {
        value: "Curacao",
        label: "Curacao",
        flag: "https://flagcdn.com/w320/cw.png",
      },
      {
        value: "Dominica",
        label: "Dominica",
        flag: "https://flagcdn.com/w320/dm.png",
      },
      {
        value: "Dominican Republic",
        label: "Dominican Republic",
        flag: "https://flagcdn.com/w320/do.png",
      },
      {
        value: "Ecuador",
        label: "Ecuador",
        flag: "https://flagcdn.com/w320/ec.png",
      },
      {
        value: "El Salvador",
        label: "El Salvador",
        flag: "https://flagcdn.com/w320/sv.png",
      },
      {
        value: "Grenada",
        label: "Grenada",
        flag: "https://flagcdn.com/w320/gd.png",
      },
      {
        value: "Guatemala",
        label: "Guatemala",
        flag: "https://flagcdn.com/w320/gt.png",
      },
      {
        value: "Guyana",
        label: "Guyana",
        flag: "https://flagcdn.com/w320/gy.png",
      },
      {
        value: "Haiti",
        label: "Haiti",
        flag: "https://flagcdn.com/w320/ht.png",
      },
      {
        value: "Honduras",
        label: "Honduras",
        flag: "https://flagcdn.com/w320/hn.png",
      },
      {
        value: "Jamaica",
        label: "Jamaica",
        flag: "https://flagcdn.com/w320/jm.png",
      },
      {
        value: "Mexico",
        label: "Mexico",
        flag: "https://flagcdn.com/w320/mx.png",
      },
      {
        value: "Nicaragua",
        label: "Nicaragua",
        flag: "https://flagcdn.com/w320/ni.png",
      },
      {
        value: "Panama",
        label: "Panama",
        flag: "https://flagcdn.com/w320/pa.png",
      },
      {
        value: "Paraguay",
        label: "Paraguay",
        flag: "https://flagcdn.com/w320/py.png",
      },
      {
        value: "Peru",
        label: "Peru",
        flag: "https://flagcdn.com/w320/pe.png",
      },
      {
        value: "Puerto Rico",
        label: "Puerto Rico",
        flag: "https://flagcdn.com/w320/pr.png",
      },
      {
        value: "Saint Kitts and Nevis",
        label: "Saint Kitts and Nevis",
        flag: "https://flagcdn.com/w320/kn.png",
      },
      {
        value: "Saint Lucia",
        label: "Saint Lucia",
        flag: "https://flagcdn.com/w320/lc.png",
      },
      {
        value: "Saint Martin (French part)",
        label: "Saint Martin (French part)",
        flag: "https://flagcdn.com/w320/sx.png",
      },
      {
        value: "Saint Vincent and the Grenadines",
        label: "Saint Vincent and the Grenadines",
        flag: "https://flagcdn.com/w320/vc.png",
      },
      {
        value: "Sint Maarten (Dutch part)",
        label: "Sint Maarten (Dutch part)",
        flag: "https://flagcdn.com/w320/sx.png",
      },
      {
        value: "Suriname",
        label: "Suriname",
        flag: "https://flagcdn.com/w320/sr.png",
      },
      {
        value: "Trinidad and Tobago",
        label: "Trinidad and Tobago",
        flag: "https://flagcdn.com/w320/tt.png",
      },
      {
        value: "Turks and Caicos Islands",
        label: "Turks and Caicos Islands",
        flag: "https://flagcdn.com/w320/tc.png",
      },
      {
        value: "United States",
        label: "United States",
        flag: "https://flagcdn.com/w320/us.png",
      },
      {
        value: "United States Virgin Islands",
        label: "United States Virgin Islands",
        flag: "https://flagcdn.com/w320/vi.png",
      },
      {
        value: "Uruguay",
        label: "Uruguay",
        flag: "https://flagcdn.com/w320/uy.png",
      },
      {
        value: "Venezuela",
        label: "Venezuela",
        flag: "https://flagcdn.com/w320/ve.png",
      },
    ],
    Continental: [
      {
        value: "American Samoa",
        label: "American Samoa",
        flag: "https://flagcdn.com/w320/as.png",
      },
      {
        value: "Australia",
        label: "Australia",
        flag: "https://flagcdn.com/w320/au.png",
      },
      {
        value: "Christmas Island",
        label: "Christmas Island",
        flag: "https://flagcdn.com/w320/cx.png",
      },
      {
        value: "Cook Islands",
        label: "Cook Islands",
        flag: "https://flagcdn.com/w320/ck.png",
      },
      {
        value: "Fiji",
        label: "Fiji",
        flag: "https://flagcdn.com/w320/fj.png",
      },
      {
        value: "French Polynesia",
        label: "French Polynesia",
        flag: "https://flagcdn.com/w320/pf.png",
      },
      {
        value: "Guam",
        label: "Guam",
        flag: "https://flagcdn.com/w320/gu.png",
      },
      {
        value: "Kiribati",
        label: "Kiribati",
        flag: "https://flagcdn.com/w320/ki.png",
      },
      {
        value: "Marshall Islands",
        label: "Marshall Islands",
        flag: "https://flagcdn.com/w320/mh.png",
      },
      {
        value: "Micronesia",
        label: "Micronesia",
        flag: "https://flagcdn.com/w320/fm.png",
      },
      {
        value: "Nauru",
        label: "Nauru",
        flag: "https://flagcdn.com/w320/nr.png",
      },
      {
        value: "New Caledonia",
        label: "New Caledonia",
        flag: "https://flagcdn.com/w320/nc.png",
      },
      {
        value: "New Zealand",
        label: "New Zealand",
        flag: "https://flagcdn.com/w320/nz.png",
      },
      {
        value: "Niue",
        label: "Niue",
        flag: "https://flagcdn.com/w320/nu.png",
      },
      {
        value: "Norfolk Island",
        label: "Norfolk Island",
        flag: "https://flagcdn.com/w320/nf.png",
      },
      {
        value: "Northern Mariana Islands",
        label: "Northern Mariana Islands",
        flag: "https://flagcdn.com/w320/mp.png",
      },
      {
        value: "Palau",
        label: "Palau",
        flag: "https://flagcdn.com/w320/pw.png",
      },
      {
        value: "Papua New Guinea",
        label: "Papua New Guinea",
        flag: "https://flagcdn.com/w320/pg.png",
      },
      {
        value: "Pitcairn Islands",
        label: "Pitcairn Islands",
        flag: "https://flagcdn.com/w320/pn.png",
      },
      {
        value: "Samoa",
        label: "Samoa",
        flag: "https://flagcdn.com/w320/ws.png",
      },
      {
        value: "Solomon Islands",
        label: "Solomon Islands",
        flag: "https://flagcdn.com/w320/sb.png",
      },
      {
        value: "Tonga",
        label: "Tonga",
        flag: "https://flagcdn.com/w320/to.png",
      },
      {
        value: "Tuvalu",
        label: "Tuvalu",
        flag: "https://flagcdn.com/w320/tv.png",
      },
      {
        value: "Vanuatu",
        label: "Vanuatu",
        flag: "https://flagcdn.com/w320/vu.png",
      },
      {
        value: "Wallis and Futuna",
        label: "Wallis and Futuna",
        flag: "https://flagcdn.com/w320/wf.png",
      },
    ],
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const allCountries = Object.entries(regions).flatMap(([region, countries]) =>
    countries.map((country) => ({
      ...country,
      region,
    }))
  );

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeRegion, setActiveRegion] = useState(null); // clicked region
  const [hoveredRegion, setHoveredRegion] = useState(null); // hovered region
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setActiveRegion(null);
        setHoveredRegion(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="bg-gradient-to-r from-[#2e5775] to-[#326e99] ">
      {user ? user.is_superuser ? <AdminNav /> : <Usernav /> : <HomeNav />}

      <section className="mt-14 ">
        <div className="py-10 px-[30px] xm:px-[10px]   w-[80%] lg:w-[90%] m-auto border rounded border-white">
          {/* Links for selecting form type */}
          <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
            <button className="text-white text-2xl mb-3 font-bold">
              Register Ship For Charter
            </button>
          </div>

          {/* Conditional Form Rendering */}

          <Link to={"/regShip"} className="px-3  text-white">
            <i className="fa-solid fa-beat fa-arrow-left "></i> Back
          </Link>

          <form className="bg-white mt-2 rounded w-[100%]">
            <div className="p-5">
              <h1 className="text-black font-bold text-xl">
                Register Ship For Charter
              </h1>
            </div>
            <hr className="text-gray-100 w-full" />
            {/* vessel type */}
            <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
              <div className=" w-[100%]">
                <label htmlFor="VesselType" className="font-semibold">
                  Vessel Type
                </label>
                <select
                  value={vesselType}
                  onChange={(e) => setvesselType(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400 p-2 text-[#d1a460]"
                  name="vesselType"
                  id="VesselType"
                >
                  <option hidden selected value="">
                    -Select-
                  </option>
                  <option
                    disabled
                    className="text-gray-500 font-semibold"
                    value=""
                  >
                    Catagories
                  </option>
                  <option value="Barge" className="text-gray-500">
                    Barge
                  </option>
                  <option value="Bulk" className="text-gray-500">
                    Bulk
                  </option>
                  <option value="Cargo" className="text-gray-500">
                    Cargo
                  </option>
                  <option value="Container" className="text-gray-500">
                    Container
                  </option>
                  <option value="Fishing" className="text-gray-500">
                    Fishing
                  </option>
                  <option value="Multipurpose" className="text-gray-500">
                    Multipurpose
                  </option>
                  <option value="Passenger/Ferry" className="text-gray-500">
                    Passenger/Ferry
                  </option>
                  <option value="Reefer" className="text-gray-500">
                    Reefer
                  </option>
                  <option value="RoRo" className="text-gray-500">
                    RoRo
                  </option>
                  <option value="Tanker" className="text-gray-500">
                    Tanker
                  </option>
                  <option value="Dredger" className="text-gray-500">
                    Dredger
                  </option>
                  <option value="Floating Crane" className="text-gray-500">
                    Floating Crane
                  </option>
                  <option value="Floating Dock" className="text-gray-500">
                    Floating Dock
                  </option>
                  <option value="Landing Craft" className="text-gray-500">
                    Landing Craft
                  </option>
                  <option value="Yacht" className="text-gray-500">
                    Yacht
                  </option>
                  <option value="Tug Boat" className="text-gray-500">
                    Tug Boat
                  </option>
                  <option value="Supply Boat" className="text-gray-500">
                    Supply Boat
                  </option>
                  <option value="crew Boat" className="text-gray-500">
                    Crew Boat
                  </option>
                  <option value="Other " className="text-gray-500">
                    Other
                  </option>
                </select>
              </div>

              <div className="w-[50%] xm:w-[100%]">
    <label className="font-bold" htmlFor="GeneratedCode">Reference Id</label>
    <input
      value={refCode}
      onChange={(e)=> setRefCode(e.target.value)}
      className="w-full mt-3 rounded border border-gray-400 p-2 text-gray-500"
      id="GeneratedCode"
      placeholder="Reference Id"
    />
  </div>
            </div>
            {/* DWT */}

            {/* nationality and inspection */}
            <div className="p-5 flex justify-between xm:flex-wrap gap-5 items-center">
              {/* Custom Dropdown for Open Area */}
              <div ref={dropdownRef} className="relative w-[50%] xm:w-full">
                <label htmlFor="Open Area" className="font-semibold">
                  Open Area
                </label>

                <div
                  className="w-full mt-2 rounded border border-gray-400 cursor-pointer text-gray-500 p-2 bg-white flex justify-between items-center"
                  onClick={() => setDropdownOpen((prev) => !prev)}
                >
                  {selectedCountry || "-Open Area-"}
                  <i className="fa-solid fa-chevron-down ml-2 text-sm"></i>
                </div>

                {dropdownOpen && (
                  <div className="absolute top-full left-0 w-full mt-2 shadow-md bg-white p-2 border rounded z-50 max-h-[300px] overflow-y-auto">
                    {allCountries.map((country) => (
                      <div
                        key={country.value}
                        className="flex items-center gap-2 py-2 px-3 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setSelectedCountry(country.label); // only label is saved
                          setDropdownOpen(false);
                        }}
                      >
                        <img src={country.flag} alt="" className="w-5 h-5" />
                        <span>{country.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* DWT */}
              <div className="xm:w-full w-[50%]">
                <label htmlFor="DWT" className="font-semibold">
                  DWT
                </label>
                <input
                  value={DWT}
                  placeholder="Enter the Capacity"
                  onChange={(e) => setDWT(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
                  id="DWT"
                />
              </div>
            </div>

           {/* Year of Built */}
            <div className="p-5 flex justify-between xm:flex-wrap gap-5 items-center ">
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Year Of Built" className="font-semibold">
                  TC/VC
                </label>
                <select
                  value={TCVC}
                  onChange={(e) => setTCVC(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400 cursor-pointer text-gray-500 p-2"
                  name=""
                  id="Nationality"
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  <option value="Time Charter">Time Charter</option>
                  <option value="Voyage Charter">Voyage Charter</option>
                </select>
              </div>
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Year Of Built" className="font-semibold">
                  Year Of Built
                </label>
                <input
                  value={YearBuilt}
                  placeholder="Enter Built Year"
                  onChange={(e) => setYearBuilt(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Year Of Built"
                />
              </div>
            </div>

            <div className="p-5 flex justify-between xm:flex-wrap gap-5 items-center ">
              
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Lychan" className="font-semibold">
                  Lychan
                </label>
                <input
                  value={Lychan}
                  placeholder="Enter Lychan"
                  onChange={(e) => setLychan(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Lychan"
                />
              </div>
            </div>

            {/* Name Company */}

            <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Name" className="font-semibold">
                  Name of Ship Owner
                </label>
                <input
                  value={name}
                  placeholder="Enter Owner Name"
                  onChange={(e) => setName(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Name"
                />
              </div>

              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Company" className="font-semibold">
                  Company of Ship Owner
                </label>
                <input
                  value={Company}
                  placeholder="Enter Company Name"
                  onChange={(e) => setCompany(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Company"
                />
              </div>
            </div>

            <div className="flex p-5 flex-col gap-1 w-[100%]">
                <label htmlFor="Company Address" className="font-semibold">
                  Company Address of Ship Owner
                </label>
                <input
                  value={CompanyAddress}
                  placeholder="Enter Company Address"
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Company"
                />
              </div>

            {/* Email Phone */}
            <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Email" className="font-semibold">
                  Email of Ship Owner
                </label>
                <input
                  value={Email}
                  
                  placeholder="Enter your Email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Email"
                />
              </div>

              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Mobile No" className="font-semibold">
                  Mobile No Of Ship Owner
                </label>
                <input
                  value={MobileNO}
                  
                  placeholder="Enter your Mobile"
                  onChange={(e) => setMobileNO(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Mobile No"
                />
              </div>
            </div>

            <div className="p-5 ">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="URL" className="font-semibold">
                   URL
                  </label>
                  <input
                    value={Url}
                    onChange={(e) => setUrl(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="url"
                    placeholder="Enter the url"
                  />
                </div>
              </div>

            {/* Brief Description */}
            <div className="p-5">
              <label htmlFor="Brief Description" className="font-semibold">
                Additional Informations
              </label>
              <textarea
                placeholder="More info..."
                value={BriefDescription}
                onChange={(e) => setBriefDescription(e.target.value)}
                rows={5}
                className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                name=""
                id="Brief Description"
              ></textarea>
            </div>

           
            <hr className="text-gray-500 w-full" />
            <div className="p-4">
              <button
                type="submit"
                onClick={(e) => handleSubmitCharter(e)}
                className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Go to Top Button */}
      {isScrolled && (
        <div
          className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
        >
          <div
            className="back-to-top px-4 hover:bg-[#615d91]"
            onClick={scrollToTop}
          >
            <i className="fa-solid fa-arrow-up text-2xl"></i>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
